(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slide-claude"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSlider(section) {
    var autoplay   = section.dataset.autoplay === 'true';
    var speed      = parseInt(section.dataset.speed, 10) || 4000;
    var loop       = section.dataset.loop === 'true';
    var transition = section.dataset.transition || 'fade';
    var trackWrap  = section.querySelector('.rslider__track-wrap');
    var slides     = Array.from(section.querySelectorAll('.rslider__slide'));
    var dots       = Array.from(section.querySelectorAll('.rslider__dot'));
    var prevBtn    = section.querySelector('.rslider__arrow--prev');
    var nextBtn    = section.querySelector('.rslider__arrow--next');

    if (!slides.length) return;

    var current     = 0;
    var total       = slides.length;
    var timer       = null;
    var isAnimating = false;
    var DURATION    = 560; // ms — match CSS transition duration

    /* ── Set track height from a specific slide's image ── */
    function setHeightFrom(idx) {
      var img = slides[idx].querySelector('.rslider__img');
      if (!img) return;

      function applyHeight() {
        if (img.naturalWidth && img.naturalHeight) {
          var ratio = img.naturalHeight / img.naturalWidth;
          trackWrap.style.height = (trackWrap.offsetWidth * ratio) + 'px';
        }
      }

      if (img.complete && img.naturalWidth) {
        applyHeight();
      } else {
        img.addEventListener('load', applyHeight, { once: true });
      }
    }

    /* Recalculate on resize */
    var resizeObserver = window.ResizeObserver
      ? new ResizeObserver(function () { setHeightFrom(current); })
      : null;
    if (resizeObserver) resizeObserver.observe(section);

    /* ── Update dots ── */
    function updateDots(idx) {
      dots.forEach(function (d, i) {
        d.classList.toggle('rslider__dot--active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    /* ── Core transition ── */
    function goTo(index, direction) {
      if (isAnimating) return;
      if (!loop && (index < 0 || index >= total)) return;

      var nextIdx = (index + total) % total;
      if (nextIdx === current) return;

      isAnimating = true;
      var prevIdx = current;
      current = nextIdx;

      updateDots(nextIdx);

      if (transition === 'slide') {
        /* --- Slide (horizontal) --- */
        var enterFrom = direction === 'prev' ? '-100%' : '100%';
        var exitTo    = direction === 'prev' ? '100%'  : '-100%';

        /* 1. Park incoming slide off-screen instantly (no transition) */
        slides[nextIdx].style.transition = 'none';
        slides[nextIdx].style.transform  = 'translateX(' + enterFrom + ')';
        slides[nextIdx].style.zIndex     = '2';
        slides[nextIdx].style.opacity    = '1';

        /* 2. Outgoing slide sits at 0 */
        slides[prevIdx].style.transition = 'none';
        slides[prevIdx].style.transform  = 'translateX(0)';
        slides[prevIdx].style.zIndex     = '1';

        /* 3. Force reflow so browser registers the transform before animating */
        slides[nextIdx].getBoundingClientRect();

        /* 4. Animate both slides */
        var tx = 'transform ' + DURATION + 'ms cubic-bezier(0.4,0,0.2,1)';
        slides[nextIdx].style.transition = tx;
        slides[nextIdx].style.transform  = 'translateX(0)';
        slides[prevIdx].style.transition = tx;
        slides[prevIdx].style.transform  = 'translateX(' + exitTo + ')';

        /* 5. Clean up after animation */
        setTimeout(function () {
          slides.forEach(function (s, i) {
            s.style.transition = '';
            s.style.transform  = '';
            s.style.zIndex     = '';
            s.style.opacity    = '';
            s.classList.toggle('rslider__slide--active', i === nextIdx);
            s.setAttribute('aria-hidden', i !== nextIdx ? 'true' : 'false');
            s.style.pointerEvents = i === nextIdx ? '' : '';
          });
          setHeightFrom(nextIdx);
          isAnimating = false;
        }, DURATION + 20);

      } else {
        /* --- Fade --- */
        /* Incoming: put behind current, make visible, then fade in */
        slides[nextIdx].style.transition = 'none';
        slides[nextIdx].style.opacity    = '0';
        slides[nextIdx].style.zIndex     = '2';

        /* Force reflow */
        slides[nextIdx].getBoundingClientRect();

        /* Fade in incoming */
        slides[nextIdx].style.transition = 'opacity ' + DURATION + 'ms ease';
        slides[nextIdx].style.opacity    = '1';

        /* Outgoing stays on top briefly then we swap */
        slides[prevIdx].style.zIndex = '1';

        setTimeout(function () {
          slides.forEach(function (s, i) {
            s.style.transition = '';
            s.style.opacity    = '';
            s.style.zIndex     = '';
            s.classList.toggle('rslider__slide--active', i === nextIdx);
            s.setAttribute('aria-hidden', i !== nextIdx ? 'true' : 'false');
          });
          setHeightFrom(nextIdx);
          isAnimating = false;
        }, DURATION + 20);
      }

      /* Update pointer events immediately */
      slides[prevIdx].style.pointerEvents = 'none';
      slides[nextIdx].style.pointerEvents = 'auto';
    }

    function nextSlide() { goTo(current + 1, 'next'); }
    function prevSlide() { goTo(current - 1, 'prev'); }

    /* ── Autoplay ── */
    function startAutoplay() {
      if (!autoplay || total < 2) return;
      timer = setInterval(nextSlide, speed);
    }
    function stopAutoplay()  { clearInterval(timer); }
    function resetAutoplay() { stopAutoplay(); startAutoplay(); }

    /* ── Controls ── */
    if (nextBtn) nextBtn.addEventListener('click', function () { nextSlide(); resetAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prevSlide(); resetAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.dotIndex, 10);
        goTo(idx, idx > current ? 'next' : 'prev');
        resetAutoplay();
      });
    });

    /* ── Swipe ── */
    var touchStartX = 0;
    var touchStartY = 0;
    section.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    section.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        dx < 0 ? nextSlide() : prevSlide();
        resetAutoplay();
      }
    }, { passive: true });

    /* ── Keyboard ── */
    section.setAttribute('tabindex', '0');
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { nextSlide(); resetAutoplay(); }
      if (e.key === 'ArrowLeft')  { prevSlide(); resetAutoplay(); }
    });

    /* ── Pause ── */
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stopAutoplay() : startAutoplay();
    });

    /* ── Init ── */
    /* Set initial height from first slide, and on every image load */
    setHeightFrom(0);
    var firstImg = slides[0] && slides[0].querySelector('.rslider__img');
    if (firstImg && !firstImg.complete) {
      firstImg.addEventListener('load', function () { setHeightFrom(0); }, { once: true });
    }
    window.addEventListener('resize', function () { setHeightFrom(current); });

    startAutoplay();
  }

  /* ── Boot ── */
  document.querySelectorAll('.rslider').forEach(initSlider);

  /* ── Shopify Theme Editor events ── */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.rslider');
      if (s) initSlider(s);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var section = e.target.closest('.rslider');
      if (!section) return;
      var slides = Array.from(section.querySelectorAll('.rslider__slide'));
      var target = e.target;
      var idx = slides.indexOf(target);
      if (idx !== -1) {
        slides.forEach(function (s, i) {
          s.classList.toggle('rslider__slide--active', i === idx);
          s.setAttribute('aria-hidden', i !== idx ? 'true' : 'false');
        });
        var dots = Array.from(section.querySelectorAll('.rslider__dot'));
        dots.forEach(function (d, i) {
          d.classList.toggle('rslider__dot--active', i === idx);
        });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
